
import { Options } from "vue-class-component";
import ComponentMixins from "../ComponentMixins";

@Options({
    name: "flowable-common-form-components-number-input",
    props: {
        placeholder: {
            type: String,
            default: "请输入数值",
        },
        readerMode: {
            type: Boolean,
            default: false,
        },
    },
})
export default class NumberInput extends ComponentMixins {}
